import { defineStore } from 'pinia'

import { StorageHelper } from '@/helpers/storage-helper'
import { RepositoryFactory } from '@/repositories/repositoryFactory'

import type { Fields } from './globalSeo.types'

interface AppError {
  message: string
}

interface GlobalSeoData {
  data: Fields
  error: AppError | null
  loading: boolean
}

const globalSeoRepository: any = RepositoryFactory.get('globalSeoRepository')

export const useGlobalSeoStore = defineStore('globalseo', {
  state: () =>
    <GlobalSeoData>{
      data: StorageHelper.getItem('globalseo', []),
      error: null,
      loading: true
    },
  getters: {
    getGlobalSeoData: (state) => state.data,
    getGlobalSeoLoading: (state) => state.loading
  },
  actions: {
    async fetchAllGlobalSeo() {
      this.loading = true
      try {
        this.data = (await globalSeoRepository.getAllGlobalSeo()).data.fields
        StorageHelper.setItem('globalseo', this.data)
      } catch (error) {
        console.error('Error fetching:', error)
        this.error = {
          message: 'problem with fetching menu'
        }
      } finally {
        this.loading = false
      }
    }
  }
})
